import React, { forwardRef, useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { BtnV2, l } from '@manychat/manyui'

import { useSelectedGoalData } from 'apps/aiAutomation/components/EngagementGoalEditor/hooks/useSelectedGoalData'
import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import {
  LeadQualPlaygroundActions,
  LeadQualPlaygroundSelectors,
} from 'apps/aiAutomation/store/leadQualPlayground'
import { ConversationEndReason } from 'apps/aiAutomation/store/leadQualPlayground/types'
import { useAssigneeOptions } from 'common/settings/components/BotAssigneePicker/useAssigneeOptions'

import cm from './ConversationFinishedControls.module.css'

export const ConversationFinishedControls = forwardRef<HTMLLIElement>((_, ref) => {
  const dispatch = useAppDispatch()

  const { selectedGoalId } = useSelectedGoalData()

  const conversationEndReason = useAppSelector(LeadQualPlaygroundSelectors.getConversationEndReason)

  const fallbackAssignee = useAppSelector(LeadQualPlaygroundSelectors.getFallbackAssignee)

  const { selectedOptionValue: selectedAssigneeOption } = useAssigneeOptions(
    fallbackAssignee ?? undefined,
  )

  const restartSession = useCallback(() => {
    if (selectedGoalId) {
      dispatch(LeadQualPlaygroundActions.sessionReset())
      dispatch(LeadQualPlaygroundActions.startSessionFx(selectedGoalId))
      AiAutomationAnalytics.logLeadQualPlaygroundStarted({
        goalId: selectedGoalId,
        action: 'restart',
      })
    }
  }, [dispatch, selectedGoalId])

  return (
    <li className={cm.conversationFinishedControls} ref={ref}>
      <p className="m-b">
        {conversationEndReason === ConversationEndReason.ACHIEVED && l.translate('Goal achieved!')}

        {conversationEndReason === ConversationEndReason.OPERATOR_REQUESTED &&
          selectedAssigneeOption &&
          l.translate('“{personOrGroupName}” will take over.', {
            personOrGroupName: selectedAssigneeOption.label,
          })}

        {conversationEndReason === ConversationEndReason.OPERATOR_REQUESTED &&
          !selectedAssigneeOption &&
          l.translate('AI stopped collecting info here.')}
      </p>

      <BtnV2 onClick={restartSession} label={l.translate('Restart preview')} leftIcon="Retry" />
    </li>
  )
})
